export default {"src":"/_next/static/media/shield.41ee78a6.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};